// @ts-nocheck
/* eslint-disable */
/* tslint:disable */
/* prettier-ignore-start */
/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */
// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: gZEhwnQAfx2q6zBpBNhhDQ
// Component: Kd3_SGR-_GH0
import * as React from "react";
import {
  classNames,
  createPlasmicElementProxy,
  deriveRenderOpts
} from "@plasmicapp/react-web";
import { useDataEnv } from "@plasmicapp/react-web/lib/host";
import LoginInput from "../../LoginInput"; // plasmic-import: IUjDjOBqC9S0/component
import "@plasmicapp/react-web/lib/plasmic.css";
import plasmic_antd_5_hostless_css from "../antd_5_hostless/plasmic_antd_5_hostless.module.css"; // plasmic-import: ohDidvG9XsCeFumugENU3J/projectcss
import projectcss from "./plasmic_collect_wise_draft.module.css"; // plasmic-import: gZEhwnQAfx2q6zBpBNhhDQ/projectcss
import sty from "./PlasmicTestNewPage.module.css"; // plasmic-import: Kd3_SGR-_GH0/css

createPlasmicElementProxy;

export const PlasmicTestNewPage__VariantProps = new Array();

export const PlasmicTestNewPage__ArgProps = new Array();

const $$ = {};

function PlasmicTestNewPage__RenderFunc(props) {
  const { variants, overrides, forNode } = props;
  const args = React.useMemo(
    () =>
      Object.assign(
        {},
        Object.fromEntries(
          Object.entries(props.args).filter(([_, v]) => v !== undefined)
        )
      ),
    [props.args]
  );
  const $props = {
    ...args,
    ...variants
  };
  const $ctx = useDataEnv?.() || {};
  const refsRef = React.useRef({});
  const $refs = refsRef.current;
  return (
    <React.Fragment>
      <div className={projectcss.plasmic_page_wrapper}>
        <div
          data-plasmic-name={"root"}
          data-plasmic-override={overrides.root}
          data-plasmic-root={true}
          data-plasmic-for-node={forNode}
          className={classNames(
            projectcss.all,
            projectcss.root_reset,
            projectcss.plasmic_default_styles,
            projectcss.plasmic_mixins,
            projectcss.plasmic_tokens,
            plasmic_antd_5_hostless_css.plasmic_tokens,
            sty.root
          )}
        >
          <LoginInput
            data-plasmic-name={"testInput"}
            data-plasmic-override={overrides.testInput}
            className={classNames("__wab_instance", sty.testInput)}
          />

          <div
            data-plasmic-name={"submitButton"}
            data-plasmic-override={overrides.submitButton}
            className={classNames(projectcss.all, sty.submitButton)}
          />

          <div
            data-plasmic-name={"tempStack"}
            data-plasmic-override={overrides.tempStack}
            className={classNames(projectcss.all, sty.tempStack)}
          />
        </div>
      </div>
    </React.Fragment>
  );
}

const PlasmicDescendants = {
  root: ["root", "testInput", "submitButton", "tempStack"],
  testInput: ["testInput"],
  submitButton: ["submitButton"],
  tempStack: ["tempStack"]
};

function makeNodeComponent(nodeName) {
  const func = function (props) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: PlasmicDescendants[nodeName],
          internalArgPropNames: PlasmicTestNewPage__ArgProps,
          internalVariantPropNames: PlasmicTestNewPage__VariantProps
        }),
      [props, nodeName]
    );
    return PlasmicTestNewPage__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName
    });
  };
  if (nodeName === "root") {
    func.displayName = "PlasmicTestNewPage";
  } else {
    func.displayName = `PlasmicTestNewPage.${nodeName}`;
  }
  return func;
}

export const PlasmicTestNewPage = Object.assign(
  // Top-level PlasmicTestNewPage renders the root element
  makeNodeComponent("root"),
  {
    // Helper components rendering sub-elements
    testInput: makeNodeComponent("testInput"),
    submitButton: makeNodeComponent("submitButton"),
    tempStack: makeNodeComponent("tempStack"),
    // Metadata about props expected for PlasmicTestNewPage
    internalVariantProps: PlasmicTestNewPage__VariantProps,
    internalArgProps: PlasmicTestNewPage__ArgProps,
    // Page metadata
    pageMetadata: {
      title: "",
      description: "",
      ogImageSrc: "",
      canonical: ""
    }
  }
);

export default PlasmicTestNewPage;
/* prettier-ignore-end */
